import { render, staticRenderFns } from "./AddEndpointButton.vue?vue&type=template&id=649b4cfe"
import script from "./AddEndpointButton.vue?vue&type=script&lang=js"
export * from "./AddEndpointButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports